import { useEffect, useState } from "react";

import { getNotifications, getUnreadCount } from "../../api/Notif";
import { formatToDateTime } from "../master/FormatToDateTime";
import Pagination from "../components/Pagination";
import Master from "../message/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";

export default function NotificationHistory() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  const [filters, setFilters] = useState({
    date_from: "",
    date_to: "",
    type: "",
    // user_id: "",
    screen: "",
    search: "",
    is_read: "",
  });

  const buildQuery = (obj) => {
    let addUrl = "";
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (value !== "" && value !== null && value !== undefined) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    return addUrl;
  };

  const getNotificationList = async () => {
    setLoading(true);
    try {
      const response = await getNotifications(buildQuery(filters));
      if (response?.data?.data) {
        setData(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getUnreadTotal = async () => {
    try {
      // unread count follows type/user_id scope only, not the full filter set
      const scopeFilters = {
        type: filters.type,
        // user_id: filters.user_id,
      };
      const response = await getUnreadCount(buildQuery(scopeFilters));
      if (response?.data?.data) {
        setUnreadCount(response.data.data.unread_count ?? 0);
      }
    } catch (err) {
      // silent fail — badge just won't update
    }
  };

  useEffect(() => {
    getNotificationList();
    getUnreadTotal();
  }, [filters]);

  const getReadClass = (isRead) => {
    return isRead === "1" || isRead === 1 ? "secondary" : "warning";
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between">
                          <h4 className="text-primary m-0">
                            Notification History
                          </h4>
                          <span className="badge bg-label-warning fs-6">
                            Unread: {unreadCount}
                          </span>
                        </div>
                        <hr />

                        {/* ================= FILTERS ================= */}
                        <div className="row g-3 mb-4">
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                className="form-control"
                                id="date_from"
                                value={filters?.date_from || ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    date_from: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="date_from">Date From</label>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                className="form-control"
                                id="date_to"
                                value={filters?.date_to || ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    date_to: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="date_to">Date To</label>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                id="type"
                                value={filters?.type || ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    type: e.target.value,
                                  })
                                }
                              >
                                <option value="">All</option>
                                <option value="student">Student</option>
                                <option value="teacher">Teacher</option>
                              </select>
                              <label htmlFor="type">Type</label>
                            </div>
                          </div>

                          {/* <div className="col-md-2">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="number"
                                className="form-control"
                                id="user_id"
                                placeholder="User Id"
                                value={filters?.user_id || ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    user_id: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="user_id">User Id</label>
                            </div>
                          </div> */}

                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                id="is_read"
                                value={filters?.is_read || ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    is_read: e.target.value,
                                  })
                                }
                              >
                                <option value="">All</option>
                                <option value="0">Unread</option>
                                <option value="1">Read</option>
                              </select>
                              <label htmlFor="is_read">Status</label>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                id="search"
                                placeholder="Search"
                                value={filters?.search || ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    search: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="search">
                                Search Title/Description
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* ================= TABLE ================= */}
                        <div className="table-responsive">
                          <table className="table table-hover align-middle">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Type</th>
                                <th>User</th>
                                <th>Title</th>
                                <th>Description</th>
                                {/* <th>Screen</th> */}
                                <th>Datetime</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.data?.length > 0 ? (
                                data.data.map((item, i) => (
                                  <tr key={item?.id ?? i}>
                                    <td>
                                      {(data.current_page - 1) * data.per_page +
                                        i +
                                        1}
                                    </td>

                                    <td className="text-capitalize">
                                      {item?.type}
                                    </td>

                                    <td>
                                      <div>{item?.user_name || "-"}</div>
                                      <small className="text-muted">
                                        Registration No:{" "}
                                        {item?.user_registration_no}
                                      </small>
                                    </td>

                                    <td
                                      style={{
                                        minWidth: "180px",
                                        maxWidth: "250px",
                                      }}
                                    >
                                      {item?.title}
                                    </td>

                                    <td
                                      style={{
                                        minWidth: "250px",
                                        maxWidth: "400px",
                                        whiteSpace: "pre-line",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {item?.description}
                                    </td>

                                    {/* <td>{item?.screen || "-"}</td> */}

                                    <td className="text-nowrap">
                                      {formatToDateTime(item?.created_at)}
                                    </td>

                                    <td>
                                      <span
                                        className={`badge bg-label-${getReadClass(
                                          item?.is_read,
                                        )}`}
                                      >
                                        {item?.is_read === "1" ||
                                        item?.is_read === 1
                                          ? "Read"
                                          : "Unread"}
                                      </span>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="8" className="text-center py-4">
                                    No notifications found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>

                          <Pagination
                            data={data}
                            setFilters={setFilters}
                            filters={filters}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
